import axios from "axios"
import url from "../utils/url";

export const postearArchivos = async (archivos) => {
    return await axios.post(`${url}/api/upload_files`, archivos);
}

